import React, { useState } from "react";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/Footer2";
import Scrolltop from "../components/Scrolltop";
import Header from "../components/Header";
import { Link } from "react-router-dom";

import Bg from "../img/services/bg3.jpg";
import banner from "../img/services/business-background-3.webp";
import banner2 from "../img/services/business-background-4.webp";
import Empresarial from "../components/Empresarial3";

import BtWhatsapp from "../components/ButtonWhatsapp3";
import LeadsTable from "../components/LeadsTable";

const ROUTER_USER = "admin";
const ROUTER_PASS = "admin";

const LeadsTablep = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    if (user === ROUTER_USER && pass === ROUTER_PASS) {
      setLoggedIn(true);
      setError("");
    } else {
      setError("Usuário ou senha incorretos.");
    }
  };

  if (!loggedIn) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          background: "#f4f4f4",
        }}
      >
        <form
          onSubmit={handleLogin}
          style={{
            background: "#fff",
            padding: 32,
            borderRadius: 8,
            boxShadow: "0 2px 12px rgba(0,0,0,0.1)",
            minWidth: 320,
            display: "flex",
            flexDirection: "column",
            gap: 16,
          }}
        >
          <h2
            style={{
              textAlign: "center",
              margin: 0,
              color: "#333",
            }}
          >
            Acesso Restrito
          </h2>
          <label>
            Usuário
            <input
              type="text"
              value={user}
              onChange={(e) => setUser(e.target.value)}
              autoFocus
              style={{
                width: "100%",
                padding: 8,
                marginTop: 4,
              }}
              autoComplete="username"
              required
            />
          </label>
          <label>
            Senha
            <input
              type="password"
              value={pass}
              onChange={(e) => setPass(e.target.value)}
              style={{
                width: "100%",
                padding: 8,
                marginTop: 4,
              }}
              autoComplete="current-password"
              required
            />
          </label>
          <button
            type="submit"
            style={{
              background: "#1976d2",
              color: "#fff",
              border: "none",
              padding: "10px 0",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            Entrar
          </button>
          {error && (
            <div
              style={{
                color: "red",
                textAlign: "center",
              }}
            >
              {error}
            </div>
          )}
        </form>
      </div>
    );
  }

  return (
    <>
      <Header />
      <main>
        <LeadsTable />
        <Footer />
      </main>

      <BtWhatsapp />
      <Scrolltop />
    </>
  );
};

export default LeadsTablep;

